<template>

    <div class="page-grid-wrapper" :class="{ 'alt-colors': altColors }">
        <div class="page-grid-fix" style="padding-bottom: 55px;">
                <h2>You may also like</h2>
            <div class="watches bordered">
                <div v-if="!isLoadingRm && manufacturername === 'Richard Mille'" class="grid-view rmlighttext">                       
                    <div v-for="variant in variantsRM" :key="variant.SKU" class="grid-item watch__card" ref="card" >
                        <router-link :to="{ name: 'rmwatch', params: { watchSKU: variant.SKU, watchModel: variant.HTMLSafeModel.split(' ').join('') } }">
                            <figure class="image-container">
                                    <img class="imageGridSource" :src="'/watches/gallery/NW-' + variant.SKU + '/grid-image/grid_NW-' + variant.SKU + '.png'" alt="" :key="variant.SKU">
                                    <img class="alternativeImageGridSource" @error="imageLoadError" :src="'/watches/gallery/NW-' + variant.SKU + '/grid-image/custom_grid_image_NW-' + variant.SKU + '.jpg'" alt="">
                                <figcaption>
                                    <p>{{ variant.ManufacturerName }} {{ variant.Model }}</p>
                                </figcaption>
                            </figure>
                        </router-link>
                    </div>
                </div>

                <div v-else-if="!isLoadingOther" class="grid-view">
                    <div v-for="variant in variantsOther" class="grid-item watch__card" ref="card">
                        <router-link :to="{ name: 'otherwatch', params: {  watchManufacturerName: variant.ManufacturerName.split(' ').join('-'), watchSKU: variant.SKU, watchModel: variant.HTMLSafeModel.split(' ').join('') } }">
                                    <figure class="image-container">
                                    <img class="imageGridSource" :src="'/watches/gallery/NW-' + variant.SKU + '/grid-image/grid_NW-' + variant.SKU + '.png'" alt="" :key="variant.SKU"  @error="handleImagePlaceholder">
                                    <img class="alternativeImageGridSource" @error="imageLoadError" :src="'/watches/gallery/NW-' + variant.SKU + '/grid-image/custom_grid_image_NW-' + variant.SKU + '.jpg'" alt="">
                                <figcaption>
                                    <p>{{ variant.ManufacturerName }} {{ variant.Model }}</p>
                                </figcaption>
                            </figure>
                        </router-link>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<style>

figure.image-container {
    position: relative;
}

img.alternativeImageGridSource {
    position: absolute;
    opacity:0;
    top: 0;
    left: 0;
}

img.alternativeImageGridSource:hover {
    opacity: 1;
}

</style>

<script>

// import { watch } from 'vue';
export default {
    name: 'WatchVariants',
    // props: ['manufacturername', 'model', 'sku', 'movement', 'material', 'gender'],
    props: {
        altColors: Boolean,
        manufacturername: String,
        model: String,
        sku: String,
        movement: String,
        material: String,
        gender: String,
    },
    
    data() {
        return {
            otherWatches: [],
            rmWatches: [],
            isLoadingRm: true, // Add a loading state
            isLoadingOther: true, // Add a loading state
        };
    },
    mounted() {
        const path = this.$route.path.toLowerCase();

        if (path.includes("richard-mille-watch")) {
            this.getAllRMWatches();
        } else if (path.includes("watch") && !path.includes("richard-mille")) {
            this.getAllOtherWatches();
        }
    },
    // watch: {
    //     '$route.path': {
    //         immediate: true,
    //         handler(newPath) {
    //         const path = newPath.toLowerCase();

    //         if (path.includes("richard-mille-watch")) {
    //             this.getAllRMWatches();
    //         } else if (path.includes("watch") && !path.includes("richard-mille")) {
    //             this.getAllOtherWatches();
    //         }
    //         }
    //     }
    // },

    methods: {
        imageLoadError(event) {
            event.target.parentNode.removeChild(event.target); // Remove the image from the DOM
        },
        handleImagePlaceholder(event) {
            // Set the src to the placeholder image if the original image fails to load
            event.target.src = '/watches/gallery/maintenance/grid_placeholder.png';
        },
        getAllOtherWatches(address) {
            this.isLoadingOther = true; 
            this.$axios.get(address ? address : "/api/otherwatches" ).then(response => {
               this.otherWatches = response.data.data;
               this.isLoadingOther = false; // Reset loading state
             });
           },
        getAllRMWatches(address) {
            this.isLoadingRm = true; 
            this.$axios.get(address ? address : "/api/rmonly" ).then(response => {
                this.rmWatches = response.data.data;
                this.isLoadingRm= false; // Reset loading state
            });
        },
    },
    computed: {
        variantsRM() {
            this.rmWatches.sort((a, b) => {
                return Math.random() - 0.5;
            });
            const filteredWatches = this.rmWatches.filter((watch) => {
                return watch.SKU !== this.sku && watch.Gender === this.gender && (watch.Movement === this.movement || watch.material === this.material);
            }).slice(0, 3);
            const uniqueSKUs = new Set(filteredWatches.map((watch) => watch.SKU));
            while (uniqueSKUs.size < 3) {
                const watchToAdd = this.rmWatches.find((watch) => {
                    return watch.SKU !== this.sku && watch.ManufacturerName === this.manufacturername && !uniqueSKUs.has(watch.SKU);
                });
                if (!watchToAdd) {
                    break;
                }
                filteredWatches.push(watchToAdd);
                uniqueSKUs.add(watchToAdd.SKU);
            }
            return [filteredWatches[0], ...filteredWatches.slice(1)];
        },

        variantsOther() {
            this.otherWatches.sort((a, b) => {
                return Math.random() - 0.5;
            });
            const filteredWatches = this.otherWatches.filter((watch) => {
                return watch.SKU !== this.sku && watch.ManufacturerName === this.manufacturername && (watch.Gender === this.gender || watch.material === this.material);
            }).slice(0, 3);
            const uniqueSKUs = new Set(filteredWatches.map((watch) => watch.SKU));
            while (uniqueSKUs.size < 3) {
                const watchToAdd = this.otherWatches.find((watch) => {
                    return watch.SKU !== this.sku && !uniqueSKUs.has(watch.SKU);
                });
                if (!watchToAdd) {
                    break;
                }
                filteredWatches.push(watchToAdd);
                uniqueSKUs.add(watchToAdd.SKU);
            }
            return [filteredWatches[0], ...filteredWatches.slice(1)];
        }
    }
}
</script>
<style scoped>
.alt-colors:deep(p) { color: white !important; }
.alt-colors.page-grid-wrapper { background-color: #090909 !important; }
</style>